import { useNavigate } from 'react-router-dom'

import { DocumentNode } from '@apollo/client'
import { DuplicateQuoteDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'

import handleResultWithFlash from 'modules/finance/lib/handleResultWithFlash'

export function useDuplicateQuote(options?: { refetchQueries?: Array<string | DocumentNode> }) {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [duplicateQuote] = useMutation(DuplicateQuoteDocument, {
    extractorFn: (data) => data.financeMutations.duplicateFinanceQuote,
    ...(options?.refetchQueries ? { refetchQueries: options.refetchQueries } : {}),
  })

  return async (quoteId: string) => {
    const result = await duplicateQuote({
      variables: {
        id: quoteId,
      },
    })

    const handled = handleResult(result, handleResultWithFlash())

    if (handled.success) {
      track(trackingEvents.accounting.quotes.conversionIntoInvoice)
      navigate(
        navigation.finance.sales.quotes.quoteId.fullPath({
          quoteId: String(handled.data.quote?.id),
        })
      )
    }
  }
}
